<template>
  <div>
    <h3>{{ materialTypeLabel }}</h3>
    <FieldDisplay
      v-for="displayField in getDisplayFields"
      :key="displayField.name"
      :display-field="displayField"
      :individual-field-data="bioMaterial[displayField.name]"
    />
  </div>
</template>

<script>
import FieldDisplay from "./FieldDisplay.vue";
import EntityViewDisplayFieldFormatter from "../../lib/entity_view_display_field_formatters";

export default {
  name: "BioMaterialRender",
  components: { FieldDisplay },
  data() {
    return {
      isBusy: false,
    };
  },
  computed: {
    getDisplayFields() {
      const displayFields = [];
      const omit = { name: true };
      if (this.displayFieldData) {
        Object.entries(this.displayFieldData).forEach((display) => {
          const [fieldName, data] = display;
          if (!omit[fieldName]) {
            const field = { name: fieldName, label: data.label };
            field.formatted = EntityViewDisplayFieldFormatter.fieldFormatter(
              this.bioMaterial[fieldName],
              data,
            );
            displayFields.push(field);
          }
        });
      }
      return displayFields;
    },
  },
  props: {
    displayFieldData: { type: Object, required: true },
    bioMaterial: { type: Object, required: true },
    materialTypeLabel: { type: String, default: "Material Details" },
  },
};
</script>

<style scoped>
h3 {
  margin-bottom: 0.5rem;
}
</style>
